module.exports = __webpack_public_path__ + "static/media/prague-heat-card.c5598bc1.png";